<template>
  <div v-if="isOpen" class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="header-coment">
        <button class="close-button mobile" @click="closeModal" aria-label="Cerrar modal">
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
            <path d="M6 0.5L1 7.5L6 14.5" stroke="#464D5B" />
          </svg>
        </button>
        <span class="title">Escribe tu comentario</span>
        <button class="close-button desktop" @click="closeModal" aria-label="Cerrar modal">
          <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
            <path d="M1 1L26 26M26 1L1 26" stroke="#464D5B" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
      </div>
      <div class="separator-line"></div>
      <textarea v-model="comment" class="text-area" placeholder="Deja tu comentario aquí"></textarea>
      <button class="custom-button" @click="submitComment">
        <span class="button-text">Enviar</span>
      </button>
      <div>
        <span class="success-message">
          Tu comentario ha sido enviado correctamente.
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommentModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:isOpen", "comment-submitted"],
  data() {
    return {
      comment: "",
      success: false,
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        document.body.classList.add("no-scroll");
      } else {
        document.body.classList.remove("no-scroll");
        this.resetForm();
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit("update:isOpen", false);
    },
    submitComment() {
      if (this.comment.trim() === "") {
        return;
      }
      const newComment = {
        comment: this.comment,
        date: new Date().toLocaleString(),
      };
      this.$emit("comment-submitted", newComment);
      this.success = true;
      setTimeout(() => {
        this.closeModal();
      }, 2000);
    },
    resetForm() {
      this.comment = "";
      this.success = false;
    },
  },
};
</script>

<style>
.no-scroll {
  overflow: hidden;
}
</style>

<style scoped>
.desktop {
  display: block;
}

.mobile {
  display: none;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.modal-content {
  width: 69.5833vw;
  height: 32.2222vw;
  padding: 2.0833vw;
  display: flex;
  flex-direction: column;
  gap: 1.3889vw;
  border-radius: 1.3889vw;
  border: 0.0694vw solid var(--background-gray, #e3e3e9);
  background: #e3e4f4;
  background-blend-mode: luminosity;
}

.title {
  color: var(--Text, #464d5b);
  font-family: Manrope, sans-serif;
  font-size: 2.7778vw;
  font-weight: 500;
}

.text-area {
  flex: 1;
  width: 100%;
  padding: 1.0417vw;
  border-radius: 2.0833vw;
  border: 0.0694vw solid var(--background-gray, #e3e3e9);
  background: #fff;
  resize: none;
  font-family: Manrope, sans-serif;
  font-size: 1.0417vw;
}

.text-area::placeholder {
  color: #9b9b9b;
}

.header-coment {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.separator-line {
  width: 100%;
  height: 0.1389vw;
  background: #ffffff;
}

.custom-button {
  padding: 0.6944vw 1.3889vw;
  border: none;
  border-radius: 20.8333vw;
  background: var(--purple, #b359f8);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.button-text {
  color: #fff;
  font-family: Manrope, sans-serif;
  font-size: 1.0417vw;
}

.success-message {
  font-family: Manrope, sans-serif;
  font-size: 0.8333vw;
  font-weight: 600;
  background: var(--gradient-2,
      linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@media (max-width: 530px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }

  .modal-content {
    border-radius: 4.5455vw;
    width: 90.9091vw;
    height: 79.5455vw;
    padding: 4.5455vw 3.4091vw;
  }

  .title {
    flex-grow: 1;
    text-align: center;
    text-align: center;
    font-size: 4.0909vw;
  }



  .text-area {
    flex: 1;
    width: 100%;
    padding: 2.2727vw;
    border-radius: 6.8182vw;
    border: 0.0694vw solid var(--background-gray, #e3e3e9);
    background: #fff;
    resize: none;
    font-family: Manrope, sans-serif;
    font-size: 3.4091vw;
  }

  .custom-button {
    padding: 2.2727vw 4.5455vw;
    gap: 2.2727vw;
    border-radius: 68.1818vw;
  }

  .button-text {
    font-size: 3.4091vw;
  }

  .success-message {
    font-size: 2.7273vw;
  }

  .separator-line {
    margin-top: 1.1364vw;
    margin-bottom: 1.1364vw;
  }
}
</style>
